import React, { useState } from "react";
import handleCSRF from "../../config/CSRF";
import { toast } from "react-toastify";
import axios from "axios";
import { apiKey } from "../../config/config";

function AddSupplierModal({ setShowModal, setSuppliers }) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [formData, setFormData] = useState({
    name: "",
    contact_person: "",
    user_id: user?.user.id,
    phone: "",
    supplier_vat: "",
    email: "",
    address: "",
    description: "",
    outlet_id: user?.user.outlet_id,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const postData = () => {
      axios
        .post(`${apiKey}/api/rms/admin/suppliers`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setSuppliers((prev) => [...prev, {
            label: res.data.name,
            value: res.data.id,
          }]);
          setShowModal(false);
        })
        .catch((err) => {
          toast.error(err.response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => setLoading(false));
    };
    handleCSRF(postData);
  };

  return (
    <div
      className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-black bg-opacity-50 backdrop-blur py-4 px-2"
      onClick={() => setShowModal(false)}
    >
      <div
        className="relative mx-auto my-auto max-w-2xl w-full"
        onClick={(e) => e.stopPropagation()}
      >
        {/*content*/}
        <form
          onSubmit={handleSubmit}
          className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none overflow-y-auto shiftmodel"
        >
          {/*header*/}
          <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">
            <h1 className="text-md text-[#7B20C7]">Add Supplier</h1>
            <button
              className="ml-auto float-right text-2xl"
              onClick={() => setShowModal(false)}
            >
              <span className="text-[#7B20C7]"> × </span>
            </button>
          </div>

          <div className="px-16">
            <div className="flex  items-center gap-10 p-3 w-full">
              <label
                htmlFor=""
                className="text-[#7B20C7] text-sm text-end mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 font-semibold before:translate-x-2 w-1/5 "
              >
                Supplier Name{" "}
              </label>
              <input
                type="text"
                placeholder="Supplier Name"
                className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-3/5 "
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </div>

            <div className="flex  items-center gap-10 p-3 w-full">
              <label
                htmlFor=""
                className="text-[#7B20C7] text-sm text-end mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 font-semibold before:translate-x-2 w-1/5"
              >
                Contact Person{" "}
              </label>
              <input
                type="text"
                placeholder="Contact Person "
                className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-3/5"
                name="contact_person"
                value={formData.contact_person}
                onChange={handleChange}
              />
            </div>

            <div className="flex  items-center gap-10 p-3 w-full">
              <label
                htmlFor=""
                className="text-[#7B20C7] text-sm text-end mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 font-semibold before:translate-x-2 w-1/5"
              >
                Phone{" "}
              </label>
              <input
                type="text"
                placeholder=" Phone "
                className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-3/5"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="flex  items-center gap-10 p-3 w-full">
              <label
                htmlFor=""
                className="text-[#7B20C7] text-sm text-end mb-2 font-semibold w-1/5"
              >
                {" "}
                Supplier VAT
              </label>
              <input
                type="text"
                placeholder=" Supplier VAT "
                className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-3/5"
                name="supplier_vat"
                value={formData.supplier_vat}
                onChange={handleChange}
              />
            </div>

            <div className="flex  items-center gap-10 p-3 w-full">
              <label
                htmlFor=""
                className="text-[#7B20C7] text-sm text-end mb-2 font-semibold w-1/5"
              >
                {" "}
                Email
              </label>
              <input
                type="text"
                placeholder=" Email "
                className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-3/5"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="flex   gap-10 p-3 w-full">
              <label
                htmlFor=""
                className="text-[#7B20C7] text-sm text-end mb-2 font-semibold w-1/5"
              >
                {" "}
                Address
              </label>
              <textarea
                rows={3}
                type="text"
                placeholder=" Address "
                className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-3/5"
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </div>

            <div className="flex gap-10 p-3 w-full">
              <label
                htmlFor=""
                className="text-[#7B20C7] text-sm text-end mb-2 font-semibold w-1/5"
              >
                {" "}
                Description
              </label>
              <textarea
                rows={4}
                type="text"
                placeholder=" Enter... "
                className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-3/5"
                name="description"
                value={formData.description}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="flex justify-end   p-3">
            <button
              className="bg-[#7B20C7] text-white text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
              type="submit"
            >
              {loading && (
                <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                  <img
                    className="w-4 mx-auto"
                    src="https://i.gifer.com/ZKZx.gif"
                    alt=""
                  />
                </span>
              )}
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddSupplierModal;
